import { render } from "./CounterApp.vue?vue&type=template&id=43b8916c&scoped=true"
import script from "./CounterApp.vue?vue&type=script&lang=js"
export * from "./CounterApp.vue?vue&type=script&lang=js"

import "./CounterApp.vue?vue&type=style&index=0&id=43b8916c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b8916c"]])

export default __exports__